import * as React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { ConfigProvider } from 'antd'
import viVN from 'antd/locale/vi_VN'

import App from './App'
import { store } from './redux/store'
import { BrowserRouter } from 'react-router-dom'
import { signalTheme } from './styles/antd-theme'
import './styles/tokens.css'
import './styles/global.css'

const container = document.getElementById('root')

if (container) {
  const root = createRoot(container)

  root.render(
    <ConfigProvider theme={signalTheme} locale={viVN}>
      <Provider store={store}>
        <BrowserRouter>
          <App />
        </BrowserRouter>
      </Provider>
    </ConfigProvider>,
  )
} else {
  throw new Error(
    "Root element with ID 'root' was not found in the document. Ensure there is a corresponding HTML element with the ID 'root' in your HTML file.",
  )
}